module.exports = __webpack_public_path__ + "media/images/icons/trash-4e2edbb981cc9a50dfbf7b22cc24d99c.svg";